import { render, staticRenderFns } from "./Boxplot.vue?vue&type=template&id=b96ebace&"
import script from "./Boxplot.vue?vue&type=script&lang=js&"
export * from "./Boxplot.vue?vue&type=script&lang=js&"
import style0 from "./Boxplot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports